import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AuthGuard, LoginGuard } from './core/services'
import { AdminDashboardComponent } from './modules/admin-dashboard'

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () => import('./core/index').then(com => com.LoginComponent),
    canActivate:[LoginGuard]
  },
  {
    path: 'dashboard',
    loadComponent: () => import('./core/index').then(com => com.MenuViewComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'settings',
    loadComponent: () => import('./components/feature/index').then(com => com.SettingsComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'admin-dashboard',
    loadComponent: () => import('./modules/index').then(com => com.AdminDashboardComponent),
    canActivate:[AuthGuard],
    children: [
      { path: '', redirectTo: 'users', pathMatch: 'full' },
      {
        path: 'users',
        loadComponent: () => import('./modules/index').then(com => com.UsersComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'applications',
        loadComponent: () => import('./modules/index').then(com => com.ApplicationsComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'group',
        loadComponent: () => import('./modules/index').then(com => com.GroupComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'role',
        loadComponent: () => import('./modules/index').then(com => com.RoleComponent),
        canActivate: [AuthGuard],
      },
    ]
  },

  

]
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
